import React from "react"
import Head from "next/head"

const DefaultLayout: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => (
    <>
        <Head>
            <title>Silversea&apos;s Booking</title>
        </Head>
        {children}
    </>
)

export default DefaultLayout
